export default __webpack_public_path__ + "static/media/xeon.4f6ecb8b.png";